/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NotificationBellOffIcon16Light } from './NotificationBellOffIcon16Light';
import { NotificationBellOffIcon16Regular } from './NotificationBellOffIcon16Regular';
import { NotificationBellOffIcon16Solid } from './NotificationBellOffIcon16Solid';
import { NotificationBellOffIcon20Light } from './NotificationBellOffIcon20Light';
import { NotificationBellOffIcon20Regular } from './NotificationBellOffIcon20Regular';
import { NotificationBellOffIcon20Solid } from './NotificationBellOffIcon20Solid';
import { NotificationBellOffIcon24Regular } from './NotificationBellOffIcon24Regular';
import { NotificationBellOffIcon24Solid } from './NotificationBellOffIcon24Solid';
import { NotificationBellOffIcon32Regular } from './NotificationBellOffIcon32Regular';
import { NotificationBellOffIcon64Regular } from './NotificationBellOffIcon64Regular';
var sizes = {
    16: {
        light: NotificationBellOffIcon16Light,
        regular: NotificationBellOffIcon16Regular,
        solid: NotificationBellOffIcon16Solid,
    },
    20: {
        light: NotificationBellOffIcon20Light,
        regular: NotificationBellOffIcon20Regular,
        solid: NotificationBellOffIcon20Solid,
    },
    24: {
        regular: NotificationBellOffIcon24Regular,
        solid: NotificationBellOffIcon24Solid,
    },
    32: {
        regular: NotificationBellOffIcon32Regular,
    },
    64: {
        regular: NotificationBellOffIcon64Regular,
    },
};
export var NotificationBellOffIcon = forwardRef('NotificationBellOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
